

export default {
    getdoctorinfo: '/api/web/v2/doctorhomepage/getdoctorinfo',
    diseases: '/api/web/v2/doctorhomepage/diseases',
    productionlist: '/api/web/v2/doctorhomepage/productionlist',
    productiondetail: '/api/web/v2/doctorhomepage/productiondetail',
    giveviews: '/api/web/v2/doctorhomepage/production/giveviews',
    givepraise: '/api/web/v2/patienteducation/production/givePraise',
    clicklinklog: '/api/web/v2/doctorhomepage/clicklinklog',
    getappletlink: '/api/web/v3/doctorhomepage/consultlist'
}
